import { render, staticRenderFns } from "./BlueTitle.vue?vue&type=template&id=dfd2b73e&"
import script from "./BlueTitle.vue?vue&type=script&lang=js&"
export * from "./BlueTitle.vue?vue&type=script&lang=js&"
import style0 from "./BlueTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports